import Image from 'next/image';

import styles from './styles.module.css';
import clsx from 'clsx';

export const MarkdownImage = ({ ...props }) => {
  const [src, size] = props.src.split('_resize_');
  const alt = props.alt;
  const [width, height] = size?.split('x') ?? [640, 400];

  const fullWidth = width === 'full' || true;

  return (
    <Image
      src={src}
      width={fullWidth ? 640 : width}
      height={height}
      alt={alt}
      className={clsx({
        [styles.image]: !props?.src.includes('_resize_'),
        [styles.imageCustomSize]: props?.src.includes('_resize_'),
        [styles.imageFullWidth]: fullWidth,
      })}
    />
  );
};
